// =============================================================================
// Optim TURPE V2 — ce que la mesure d'un lancement compte comme SURCHARGE
// (événements « Optim V2 Study Launched » et « Optim V2 Input Overridden »).
//
// Sorti de la page (finitions 2 du 07/10/2026) pour être testé, règle
// inchangée. Une surcharge est une ENTRÉE DU REGISTRE corrigée (plan de mesure,
// `core/tracking/plan.yaml`) : la marge de prudence n'en est pas une. Celle que
// la relance recommandée et « Ajuster l'étude » posent d'office (0,05, le
// défaut de la page) ne doit donc jamais compter comme une surcharge.
// =============================================================================

import type { OptimTurpeV2RunBody } from "@modules/courtage/services/optim-turpe-v2.service"

/** Les chemins d'entrée réellement surchargés par ce lancement, ou `undefined`. */
export function cheminsSurcharges(
    overrides?: OptimTurpeV2RunBody
): string[] | undefined {
    if (!overrides) return undefined
    const chemins: string[] = []
    if (overrides.structure_tarifaire?.formule_tarifaire_acheminement?.fta) {
        chemins.push("structure_tarifaire.formule_tarifaire_acheminement.fta")
    }
    if (overrides.structure_tarifaire?.puissance_souscrite_soutirage) {
        chemins.push("structure_tarifaire.puissance_souscrite_soutirage")
    }
    if (
        overrides.compteur?.raccordement?.puissance_raccordement_soutirage !=
        null
    ) {
        chemins.push("compteur.raccordement.puissance_raccordement_soutirage")
    }
    if (overrides.optimisation?.bornes?.raccordement_levee) {
        chemins.push("optimisation.bornes.raccordement_levee")
    }
    if (overrides.comptage?.plages_horaires?.heures_creuses) {
        chemins.push("comptage.plages_horaires.heures_creuses")
    }
    return chemins.length > 0 ? chemins : undefined
}
